import type { GlobalTranslations } from '../interfaces/global';

export const globalTranslations: GlobalTranslations = {
  input_error_invalid_email: 'Insira um e-mail válido.',
  input_error_required: 'Este campo é obrigatório',
  input_error_min_length:
    'Este campo deve ter pelo menos {{length}} caracteres',
  logout: 'Sair',
  input_error_phone_indicative_required: 'O indicativo é obrigatório',
  input_error_phone_required: 'O número de telefone é obrigatório',
  input_error_register_code:
    'O formato deve ser xxxxxxxxxxxxxx== onde x são letras, números e símbolos.',
  input_error_phone_invalid:
    'O número de telefone não tem um formato válido para o país selecionado',
  input_error_not_terms: 'Você deve aceitar nossos termos e condições',
  error_login_credentials: 'Verifique seu usuário ou senha.',
  successful_deletion_message: 'Foi excluído com sucesso.',
  successful_disabled_message: 'Foi desativado com sucesso.',
  successful_active_message: 'Foi ativado com sucesso.',
  successful_create_message: 'Foi criado com sucesso.',
  successful_update_message: 'Atualizado com sucesso.',
  error_token_message:
    'Ocorreu um erro devido à inexistência ou uso prévio do token. Por favor, gere um novo token para continuar.',
  input_date_placeholder: 'Selecione uma data',
  input_optional_label: '(opcional)',
  input_show_password_label: 'Mostrar senha',
  input_hide_password_label: 'Ocultar senha',
  input_search_placeholder: 'Procurar',
  input_phone_number_placeholder: 'Insira seu número de telefone',
  input_phone_number_label: 'Número de telefone',
  not_found_message: 'Nenhum resultado encontrado',
  input_phone_label: 'Telefone',
  input_phone_placeholder: 'Insira o número de telefone',
  sidebar_settings_label: 'Configurações',
  sidebar_customers_label: 'Clientes',
  sidebar_chats_label: 'Conversas',
  sidebar_reports_label: 'Relatórios',
  sidebar_agents_label: 'Agentes',
  sidebar_products_label: 'Catálogo',
  sidebar_templates_label: 'Modelos',
  sidebar_groups_label: 'Grupos',
  sidebar_meta_ads_label: 'Meta Ads',
  sidebar_account_label: 'Minha conta',
  sidebar_organization_label: 'Organização',
  sidebar_group_main_label: 'Principal',
  notifications_title: 'Notificações',
  notifications_empty_title: 'Sem notificações',
  pagination_records: 'Mostrando {{from}} a {{to}} de {{total}} resultados',
  pagination_empty: 'Sem resultados',
  pagination_prev_page: 'Página anterior',
  pagination_next_page: 'Próxima página',
  app_error_title: 'Algo deu errado',
  app_error_description:
    'Não conseguimos carregar esta tela. O relatório já chegou até nós e estamos verificando.',
  app_error_retry: 'Tentar de novo',
  impersonation_banner: 'Sessão de suporte: você está vendo a conta de {{email}}. Tudo o que você mudar aqui muda para o cliente.',
};
